// /* global SideDrawer */

// class CartDrawer extends SideDrawer {
//   connectedCallback() {
//     this.bindEvents();
//   }

//   bindEvents() {
//     this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
//     this.closeDrawerViaEventHandler = this.close.bind(this, null);
//     document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//     document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
//     document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
//     this.addEventListener('on:cart-drawer:before-open', () => {
//       theme.manuallyLoadImages(this);
//       this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
//     });
//     this.addEventListener('on:cart:after-merge', () => {
//       theme.manuallyLoadImages(this);
//       this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
//     });
//   }

//   disconnectedCallback() {
//     document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
//     document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
//     document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
//   }

//   /**
//    * Handle when the drawer is opened via an event
//    * @param {object} evt - Event object.
//    */
//   handleDrawerOpenViaEvent(evt) {
//     this.open(evt.detail ? evt.detail.opener : null);
//   }

//   /**
//    * Trigger refresh of contents
//    */
//   cartRefreshHandler() {
//     this.querySelector('cart-form').refresh();
//   }

//   /**
//    * Update section's cart-form element with new contents
//    * @param {string} html - Whole-section HTML.
//    */
//   updateFromCartChange(html) {
//     this.querySelector('cart-form').refreshFromHtml(html);
//   }
// }

// window.customElements.define('cart-drawer', CartDrawer);


/* global SideDrawer */

class CartDrawer extends SideDrawer {
  connectedCallback() {
    this.bindEvents();
  }

  bindEvents() {
    this.openDrawerViaEventHandler = this.handleDrawerOpenViaEvent.bind(this);
    this.closeDrawerViaEventHandler = this.close.bind(this, null);
    document.addEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
    document.addEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    this.addEventListener('on:cart-drawer:before-open', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
    this.addEventListener('on:cart:after-merge', () => {
      theme.manuallyLoadImages(this);
      this.querySelectorAll('cc-cart-cross-sell').forEach((el) => el.init());
    });
  }

  disconnectedCallback() {
    document.removeEventListener('dispatch:cart-drawer:refresh', this.cartRefreshHandler);
    document.removeEventListener('dispatch:cart-drawer:open', this.openDrawerViaEventHandler);
    document.removeEventListener('dispatch:cart-drawer:close', this.closeDrawerViaEventHandler);
  }

  /**
   * Handle when the drawer is opened via an event
   * @param {object} evt - Event object.
   */
  handleDrawerOpenViaEvent(evt) {
    this.open(evt.detail ? evt.detail.opener : null);
  }

  /**
   * Trigger refresh of contents
   */
  cartRefreshHandler() {
    this.querySelector('cart-form').refresh();
  }

  /**
   * Update section's cart-form element with new contents
   * @param {string} html - Whole-section HTML.
   */
  updateFromCartChange(html) {
    this.querySelector('cart-form').refreshFromHtml(html);
  }
}

window.customElements.define('cart-drawer', CartDrawer);

// Upsell Add to Cart - AJAX functionality
document.addEventListener('click', function(e) {
  const btn = e.target.closest('.js-upsell-add');
  if (!btn) return;
  
  e.preventDefault();
  e.stopPropagation();
  
  const variantId = btn.dataset.variantId;
  const productBlock = btn.closest('product-block') || btn.closest('.product-block') || btn.closest('.slider__item');
  if (!variantId) return;
  
  btn.disabled = true;
  
  const cartDrawer = document.querySelector('cart-drawer');
  let addedProductId = null;
  
  fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ id: variantId, quantity: 1 })
  })
  .then(res => res.json())
  .then(data => {
    // Store the added product ID for fetching related products
    addedProductId = data.product_id;
    
    // Remove the product from "You may like" section with animation
    if (productBlock) {
      productBlock.style.transition = 'opacity 0.3s, transform 0.3s';
      productBlock.style.opacity = '0';
      productBlock.style.transform = 'scale(0.9)';
      setTimeout(() => productBlock.remove(), 300);
    }
    
    // Fetch updated cart data
    return fetch('/cart.js');
  })
  .then(res => res.json())
  .then(cart => {
    if (!cartDrawer) return;
    
    // Update cart count in header
    const headerTitle = cartDrawer.querySelector('[data-merge="header-title"]');
    if (headerTitle) {
      const countSpan = headerTitle.querySelector('.cart-drawer__title-count');
      if (countSpan) {
        countSpan.textContent = `(${cart.item_count})`;
      }
    }
    
    // Update header nav cart count
    document.querySelectorAll('.js-cart-count').forEach(el => {
      el.textContent = cart.item_count;
    });
    
    // Fetch and update cart items, footer, AND cross-sells
    return fetch(window.location.pathname + '?section_id=cart-drawer');
  })
  .then(res => res.text())
  .then(html => {
    if (!cartDrawer) return;
    
    const parser = new DOMParser();
    const doc = parser.parseFromString(html, 'text/html');
    
    // Update cart items list
    const newItems = doc.querySelector('[data-merge-list="cart-items"]');
    const currentItems = cartDrawer.querySelector('[data-merge-list="cart-items"]');
    if (newItems && currentItems) {
      currentItems.innerHTML = newItems.innerHTML;
      // Trigger lazy loading of images
      if (typeof theme !== 'undefined' && theme.manuallyLoadImages) {
        theme.manuallyLoadImages(currentItems);
      }
    }
    
    // Update footer (subtotal)
    const newFooter = doc.querySelector('[data-merge="footer"]');
    const currentFooter = cartDrawer.querySelector('[data-merge="footer"]');
    if (newFooter && currentFooter) {
      currentFooter.innerHTML = newFooter.innerHTML;
    }

     // Update free shipping progress bar
    const newFreeShipping = doc.querySelector('[data-merge="free-shipping"]');
    const currentFreeShipping = cartDrawer.querySelector('[data-merge="free-shipping"]');
    if (newFreeShipping && currentFreeShipping) {
      currentFreeShipping.outerHTML = newFreeShipping.outerHTML;
    }
    
    // Show cart content if it was hidden (empty cart)
    const cartContent = cartDrawer.querySelector('.cart-drawer__content');
    if (cartContent) cartContent.classList.remove('cart-drawer__content--hidden');
    
    const cartFooter = cartDrawer.querySelector('.cart-drawer__footer');
    if (cartFooter) cartFooter.classList.remove('cart-drawer__footer--hidden');
    
    const emptyContent = cartDrawer.querySelector('.cart-drawer__empty-content');
    if (emptyContent) emptyContent.classList.add('cart-drawer__empty-content--hidden');
    
    // Update the cross-sells section with new related products
    const newCrossSells = doc.querySelector('.cart-item-upsells');
    const currentCrossSells = cartDrawer.querySelector('.cart-item-upsells');
    if (newCrossSells && currentCrossSells) {
      currentCrossSells.innerHTML = newCrossSells.innerHTML;
      // Re-initialize the carousel and cross-sell components
      currentCrossSells.querySelectorAll('carousel-slider').forEach(el => {
        if (el.refresh) el.refresh();
      });
      // Trigger cc-cart-cross-sell to fetch new recommendations
      currentCrossSells.querySelectorAll('cc-cart-cross-sell').forEach(el => {
        if (el.init) el.init();
      });
    }
  })
  .catch(err => console.error('Error adding to cart:', err))
  .finally(() => { btn.disabled = false; });
});
